






























































































































import { ContractsPanelVue } from "fs-pb-vue2/vueModels/contracts-panel/ContractsPanelVue";
import { Component } from "vue-property-decorator";
import ContractBlock from "@/components/contracts-panel/ContractBlock.vue";
import DepositBlock from "@/components/contracts-panel/DepositBlock.vue";
import CreditBlock from "@/components/contracts-panel/CreditBlock.vue";
import Preloader from "@/components/app/Preloader.vue";
import SliderAdaptiv from "@/components/app/SliderAdaptiv.vue";

@Component({
  components: { ContractBlock, DepositBlock, CreditBlock, Preloader, SliderAdaptiv }
})
export default class ContractsPanel extends ContractsPanelVue {

  contractsFlag: boolean = true;

  depositsFlag: boolean = true;

  creditsFlag: boolean = true;

  toggleList(callerId: string, targetId: string, flagName: string): void {
    const caller = document.getElementById(callerId);
    const target = document.getElementById(targetId);
    if (caller && target) {
      const isCollapsed = target.getAttribute("data-collapsed") === "true";

      if (isCollapsed) {
        this[flagName] = true;
        caller.classList.add("fs-rotate-180");
        target.setAttribute("data-collapsed", "false");
      } else {
        this[flagName] = false;
        caller.classList.remove("fs-rotate-180");
        target.setAttribute("data-collapsed", "true");
      }
    }
  }

  get windowWidthCalc(): number {
    return window.innerWidth;
  }

  get preApprovedSolutionData() {
    return this.$store.state.config.preApprovedSolutionData;
  }
}
